import { TelegramAdapter } from './TelegramAdapter';
import { MockTelegramAdapter } from './MockTelegramAdapter';

export type Adapter = TelegramAdapter | MockTelegramAdapter;

let instance: Adapter | null = null;

export function getTelegramAdapter(): Adapter {
  if (!instance) {
    const isTelegram = typeof window !== 'undefined' && !!window.Telegram?.WebApp;
    instance = isTelegram ? new TelegramAdapter() : new MockTelegramAdapter();
  }
  return instance;
}

export type { TelegramUser, SafeAreaInsets } from './TelegramAdapter';
